// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"14979792","453":"56705e19"}[chunkId] + ".chunk.js";
};